import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'MachinesParts'
const DB_VERSION = 1
const STORE_NAME = 'MachinesPartsList'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    {
        name: STORE_NAME,
        keyPath: 'id',
        indices: [
            { name: 'nameModel', keyPath: 'nameModel', options: { unique: false } }
        ]
    }
])

const initDb = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    // Original chained with consultar. We'll just do the add.
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, Number(clave), database)
}

const buscarPorNombreModelo = (value, database) => {
    return dbInstance.getByIndex(STORE_NAME, 'nameModel', value, database)
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    // Original chained with consultar.
    return dbInstance.delete(STORE_NAME, clave, database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDb,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar,
    buscarPorNombreModelo
}
